const handleHomepageProducts = async () => {
	const productBlocks = document.querySelectorAll('.products-block')
	productBlocks.forEach((block) => {
		$(block).slick(window.productsSlickSettings)
	})
}
if (dataLayer[0].shoptet.pageType === 'homepage') handleHomepageProducts()

// const handleFooterBanners = () => {
// 	const footerBanners = document.querySelector('.footer-banners')
// 	const welcomeContainer = document.querySelector('.homepage-box.welcome-wrapper')
// 	if (footerBanners && welcomeContainer) {
// 		const footerBannersContainer = document.createElement('div')
// 		footerBannersContainer.classList.add('container', 'footer-banners-container')
// 		footerBannersContainer.appendChild(footerBanners)
// 		welcomeContainer.parentElement.insertBefore(footerBannersContainer, welcomeContainer.nextElementSibling)
// 	}
// }
// if (dataLayer[0].shoptet.pageType === 'homepage') handleFooterBanners()

const handleBodyBanners = () => {
	const bodyBanners = document.querySelector('.body-banners')
	const carouselContainer =
		document.querySelector('.before-carousel .container') || document.querySelector('.row.banners-row:first-of-type')
	if (bodyBanners && carouselContainer) carouselContainer.appendChild(bodyBanners)
}
if (dataLayer[0].shoptet.pageType === 'homepage') handleBodyBanners()

// ANIMACE
let target = document.querySelectorAll('.products-block')
const target2 = document.querySelector('.top-categories-grid')
function handleIntersection(entries) {
	entries.map((entry, index) => {
		entry.target.style.removeProperty('--animation-delay')
		entry.target.setAttribute(
			'style',
			entry.target.getAttribute('style')
				? entry.target.getAttribute('style') + `--animation-delay: ${index}`
				: `--animation-delay: ${index}`,
		)
		// entry.target.setAttribute('animation-delay', `${index}`)
		if (entry.isIntersecting) {
			entry.target.classList.add('visible')
		}
	})
}
const observer = new IntersectionObserver(handleIntersection)
const observer2 = new IntersectionObserver(handleIntersection)
if (target.length) {
	target.forEach((item) => {
		item.classList.add('animation')
		const subtargets = item.querySelectorAll('.product')
		subtargets.forEach((subtarget) => {
			observer.observe(subtarget)
		})
	})
}
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', () => {
	if (target.length) {
		target.forEach((item) => {
			item.classList.add('animation')
			const subtargets = item.querySelectorAll('.product')
			subtargets.forEach((subtarget) => {
				observer.observe(subtarget)
			})
		})
	}
})
if (target2) {
	target2.classList.add('animation')
	const subtargets = target2.querySelectorAll('.category')
	subtargets.forEach((subtarget) => {
		observer2.observe(subtarget)
	})
}

// if (dataLayer[0].shoptet.pageType === 'category') {
// 	;(async () => {
// 		let faqBanner = window.sessionStorage.getItem('faqBanner')
// 		if (!faqBanner) {
// 			const response = await fetch('/')
// 			const data = await response.text()
// 			const parser = new DOMParser()
// 			const doc = parser.parseFromString(data, 'text/html')
// 			const faqBannerEl = doc.querySelector('.faq-banner')
// 			if (faqBannerEl) {
// 				window.sessionStorage.setItem('faqBanner', faqBannerEl.outerHTML)
// 				faqBanner = faqBannerEl.outerHTML
// 			}
// 		}
// 		const faqBannerContainer = document.createElement('div')
// 		faqBannerContainer.classList.add('container')
// 		faqBannerContainer.innerHTML = faqBanner
// 		const whereToPrepend = document.querySelector('.newsletter-wrapper') || document.querySelector('#footer')
// 		whereToPrepend.parentElement.insertBefore(faqBannerContainer, whereToPrepend)
// 	})()
// }

// const handleCustomFooter = (footer) => {
// 	const socialIcons = footer.querySelector('.footer-icons')
// 	const instagram = document.querySelector('.custom-footer__instagram')
// 	if (socialIcons && instagram) {
// 		const toRemove = socialIcons.closest('.footer-links-icons')
// 		instagram.prepend(socialIcons)
// 		toRemove.remove()
// 	}
// 	if (instagram) {
// 		const instagramHeading = instagram.querySelector('h4')
// 		if (instagramHeading) instagramHeading.innerHTML = 'Sledujte nás <br /> na Instagramu'
// 	}
// }
// const footer = document.querySelector('#footer')
// if (footer) handleCustomFooter(footer)

const getProductDetailData = async (guid) => {
	try {
		const response = await fetch(`https://music-city-prod.axfone.eu/api/shoptet/products/get-variants?guid=${guid}`)
		const data = await response.json()
		if (data.status === 1) return data.data
		return false
	} catch (e) {
		console.error(e)
	}
}
const createInfoBox = (data) => {
	const box = document.createElement('div')
	box.classList.add('info-box')
	if (data.background_color !== '') box.style.backgroundColor = data.background_color
	if (data.border_color !== '') box.style.borderColor = data.border_color
	if (data.text_color !== '') box.style.color = data.text_color
	box.innerHTML = data.text
	return box
}
const createSingleVariantBox = (data, withPrice) => {
	const variantBox = document.createElement('a')
	variantBox.classList.add('single-variant')
	variantBox.href = data.url
	variantBox.innerHTML = `
		<img src="${data.image}" alt="${data.code}" width="100" height="100" />
		<span>${data.name}</span>
		${
			withPrice
				? '<span class="price">' +
					Number(data.price_with_vat).toLocaleString('cs-CZ') +
					' ' +
					dataLayer[0].shoptet.currencyInfo.symbol +
					'</span>'
				: ''
		}
	`
	return variantBox
}
const createVariantsWrapper = (title, data, withPrice = false) => {
	const variantsWrapper = document.createElement('div')
	variantsWrapper.classList.add('variants-wrapper')
	const variantsTitle = document.createElement('div')
	variantsTitle.classList.add('variants-title')
	variantsTitle.innerHTML = title
	variantsWrapper.appendChild(variantsTitle)
	const variantsInner = document.createElement('div')
	variantsInner.classList.add('variants-inner')
	variantsWrapper.appendChild(variantsInner)
	for (let variant of data) {
		variantsInner.appendChild(createSingleVariantBox(variant, withPrice))
	}
	return variantsWrapper
}

const handleCustomDetail = async () => {
	// const extendedDescTable = document.querySelector(
	//   ".extended-description .detail-parameters"
	// );
	// if (extendedDescTable) {
	//   const extendedDescThead = document.createElement("thead");
	//   const extendedDescTr = document.createElement("tr");
	//   const extendedDescTh = document.createElement("th");
	//   extendedDescTh.colSpan = 2;
	//   extendedDescTh.innerHTML = "fff";
	//   extendedDescTr.appendChild(extendedDescTh);
	//   extendedDescThead.appendChild(extendedDescTr);
	//   extendedDescTable.prepend(extendedDescThead);
	// }

	const productGUID = dataLayer[0].shoptet.product.guid
	const productData = await getProductDetailData(productGUID)
	if (productData) {
		const pInfoWrapper = document.querySelector('.p-info-wrapper')
		if (productData.infoboxes?.length) {
			for (let infobox of productData.infoboxes) {
				pInfoWrapper.appendChild(createInfoBox(infobox))
			}
		}
		if (productData.variants?.length) pInfoWrapper.appendChild(createVariantsWrapper('Varianty', productData.variants, true))

		// if (productData.similar_products?.length)
		//   pInfoWrapper.appendChild(
		//     createVariantsWrapper(
		//       "Podobné produkty",
		//       productData.similar_products,
		//       true
		//     )
		//   );

		// if (productData.flags.Stock_Stav !== "") {
		//   const stockInfo = document.createElement("div");
		//   stockInfo.classList.add("stock-info");
		//   stockInfo.innerHTML = "Popis stavu: " + productData.flags.Stock_Stav;
		//   pInfoWrapper.appendChild(stockInfo);
		// }
		// const productDostupnost = productData.stocks.find(
		//   (item) => item.varinat_code === dataLayer[0].shoptet.product.code
		// );
		// if (productDostupnost) {
		//   const stockPha = parseInt(productDostupnost.stock_PHA);
		//   const stockUha = parseInt(productDostupnost.stock_UHA);
		//   const stockLou = parseInt(productDostupnost.stock_LOU);
		//   const stocksWrapper = document.createElement("div");
		//   stocksWrapper.classList.add("stocks-wrapper");
		//   stocksWrapper.innerHTML = `
		// 		<div class="stocks-row">
		// 			<div class="stocks-title">Skladem prodejna Praha:</div>
		// 			<div class="stocks-inner">${stockPha > 5 ? ">5" : stockPha} ks</div>
		// 		</div>
		// 		<div class="stocks-row">
		// 			<div class="stocks-title">Skladem prodejna Uherské Hradiště:</div>
		// 			<div class="stocks-inner">${stockUha > 5 ? ">5" : stockUha} ks</div>
		// 		</div>
		// 		<div class="stocks-row">
		// 			<div class="stocks-title">Skladem centrální sklad (Louny):</div>
		// 			<div class="stocks-inner">${stockLou > 5 ? ">5" : stockLou} ks</div>
		// 		</div>
		// 	`;
		//   pInfoWrapper.appendChild(stocksWrapper);
		// }

		// const productOutOfStock = productData?.availability_info;
		// if (productOutOfStock) {
		//   const productOnTheWay = productOutOfStock.VolneKusyNaCeste;
		//   const productAtSupplier = productOutOfStock.MaDodavatelSkladem;
		//   const onTheWayWrapper = document.createElement("div");
		//   const availabilityWrapper = document.querySelector(
		//     ".p-info-wrapper .availability-value"
		//   );
		//   availabilityWrapper.prepend(onTheWayWrapper);
		//   onTheWayWrapper.classList.add("additional-delivery-info");
		//   if (productOnTheWay) {
		//     const availabilityLabel = document.querySelector(
		//       ".p-info-wrapper .availability-label"
		//     );
		//     if (availabilityLabel) {
		//       const amountOnTheWay = document.createElement("span");
		//       amountOnTheWay.classList.add("availability-amount");
		//       amountOnTheWay.innerHTML = `(${productOnTheWay} ks)`;
		//       availabilityLabel.appendChild(amountOnTheWay);
		//     }
		//     onTheWayWrapper.innerHTML = `Očekávané datum naskladnění: ${new Date(
		//       productOutOfStock.KdyPrijdouNoveVolneKusy
		//     ).toLocaleDateString()}`;
		//   } else if (productAtSupplier === "yes") {
		//     const atSupplierAmount = productOutOfStock.PocetKusuUDodavatele;
		//     const atSupplierDate = productOutOfStock.DniOdObjednaniUDodavatele;
		//     if (atSupplierAmount) {
		//       const availabilityAmountSupplier = document.createElement("span");
		//       availabilityAmountSupplier.classList.add("availability-amount");
		//       const availabilityLabel = document.querySelector(
		//         ".p-info-wrapper .availability-label"
		//       );
		//       if (availabilityLabel)
		//         availabilityLabel.parentElement.insertBefore(
		//           availabilityAmountSupplier,
		//           availabilityLabel.nextElementSibling
		//         );
		//     }
		//     if (atSupplierDate) {
		//       const availabilityLabel = document.querySelector(
		//         ".p-info-wrapper .availability-label"
		//       );
		//       console.log(atSupplierAmount);

		//       if (availabilityLabel && atSupplierAmount) {
		//         const amountOnTheWay = document.createElement("span");
		//         amountOnTheWay.classList.add("availability-amount");
		//         amountOnTheWay.innerHTML = `(${atSupplierAmount} ks)`;
		//         availabilityLabel.appendChild(amountOnTheWay);
		//       }
		//       onTheWayWrapper.innerHTML = `Přibližná doba dodání: ${atSupplierDate} dní`;
		//     }
		//   }
		// }

		// const variantLists = pInfoWrapper.querySelectorAll(".variants-inner");
		// if (variantLists.length) {
		//   for (let list of variantLists) {
		//     $(list).slick({
		//       slidesToShow: 4,
		//       infinite: false,
		//       responsive: [
		//         {
		//           breakpoint: 1100,
		//           settings: {
		//             slidesToShow: 3,
		//           },
		//         },
		//         {
		//           breakpoint: 1000,
		//           settings: {
		//             slidesToShow: 2,
		//           },
		//         },
		//         {
		//           breakpoint: 903,
		//           settings: {
		//             slidesToShow: 5,
		//           },
		//         },
		//         {
		//           breakpoint: 800,
		//           settings: {
		//             slidesToShow: 4,
		//           },
		//         },
		//         {
		//           breakpoint: 670,
		//           settings: {
		//             slidesToShow: 3,
		//           },
		//         },
		//         {
		//           breakpoint: 540,
		//           settings: {
		//             slidesToShow: 2.4,
		//           },
		//         },
		//       ],
		//     });
		//   }
		// }
	}
}
const productVideos = document.querySelector('#productVideos')
if (productVideos) {
	const basicDescription = document.querySelector('.basic-description')
	if (basicDescription) {
		basicDescription.appendChild(productVideos)
	}
}
// 		const iframes = productVideos.querySelectorAll('iframe')
// 		const headings = productVideos.querySelectorAll('h3')
// 		const helpDescriptionTab = document.querySelector('#description')
// 		const videosWrapper = document.createElement('div')
// 		videosWrapper.classList.add('videos-wrapper')
// 		const videosHeading = document.createElement('h2')
// 		videosHeading.innerHTML = 'Video k produktu'
// 		videosWrapper.appendChild(videosHeading)
// 		const videoTabLink = document.querySelector('.shp-tab-link[href="#productVideos"]')
// 		if (videoTabLink) videoTabLink.parentElement.remove()
// 		iframes.forEach((video, index) => {
// 			const videoContainer = document.createElement('div')
// 			videoContainer.classList.add('video-container')
// 			videoContainer.appendChild(video)
// 			videoContainer.appendChild(headings[index])
// 			videosWrapper.appendChild(videoContainer)
// 		})
// 		helpDescriptionTab.appendChild(videosWrapper)
// 	}
// }
// if (dataLayer[0].shoptet.pageType === "productDetail") handleCustomDetail();
const createElement = (tag, classes = [], text = '') => {
	const element = document.createElement(tag)
	classes.forEach((className) => element.classList.add(className))
	element.textContent = text
	return element
}
// moves table variants to p-info-wrapper, creates heading and removes the variant shp-tab and button choose-variant
const handleVariantsTable = () => {
	// if (document.querySelector(".p-info-wrapper #variants")) return;
	const variantsTable = document.querySelector('#variants')
	const shpTabsWrapper = document.querySelector('.shp-tabs-row')
	const variantsTableShpTab = document.querySelector('.shp-tab[data-testid="tabVariants"]')
	if (!variantsTable) return

	if (variantsTableShpTab) variantsTableShpTab.remove()
	// if (detailInfo) detailInfo.after(variantsTable);
	// else if (pInfoWrapper) pInfoWrapper.appendChild(variantsTable);
	if (!document.querySelector('.varians-heading')) {
		const variantsTableHeading = document.createElement('h3')
		variantsTableHeading.classList.add('variants-heading')
		variantsTableHeading.innerHTML = 'Zvolte variantu'

		variantsTable.prepend(variantsTableHeading)
	}
	shpTabsWrapper.before(variantsTable)

	// removes the button choose-variant
	const chooseVariant = document.querySelector('a#choose-variant')
	if (chooseVariant) {
		const chooseVariantParent = chooseVariant.parentElement
		if (chooseVariantParent) chooseVariantParent.remove()
	}
	// on desktop, moves variant-price-wrap before btn-cart for every variant
	const variantRows = variantsTable.querySelectorAll('.variant-table .table-row')
	if (!variantRows.length) return
	variantRows.forEach((row) => {
		if (window.innerWidth > 767) {
			const variantPriceWrap = row.querySelector('.variant-price-wrap')
			const addToCartBtn = row.querySelector('.btn-cart.btn')
			if (variantPriceWrap && addToCartBtn) {
				variantPriceWrap.closest('.table-col')?.remove()
				addToCartBtn.before(variantPriceWrap)
			}
		} else {
			const tableColCart = row.querySelector('.table-col.cart')
			const infoWrapper = row.querySelector('.variant-name-wrapper .variant-image + div')
			if (infoWrapper) {
				const availabilitySpans = infoWrapper.querySelectorAll('span')
				if (availabilitySpans.length) {
					const availabilitySpan = createElement('div', ['variant-availability'])
					availabilitySpans.forEach((span) => {
						availabilitySpan.appendChild(span)
					})
					if (tableColCart) {
						tableColCart.prepend(availabilitySpan)
					} else row.appendChild(availabilitySpan)
				}
			}
		}
		const quantityBlocks = row.querySelectorAll('.quantity')

		quantityBlocks.forEach((quantity) => {
			const input = quantity.querySelector('input[type="number"]')
			const decreaseTooltip = quantity.querySelector('.js-decrease-tooltip')
			const decreaseBtn = quantity.querySelector('.decrease')

			if (!input) return

			input.min = 0
			input.value = 0

			// tooltip cleanup
			if (decreaseTooltip) {
				decreaseTooltip.setAttribute('data-original-title', '')
				decreaseTooltip.classList.remove('tooltip', 'show')
			}

			if (decreaseBtn) {
				decreaseBtn.addEventListener('click', () => {
					let value = parseInt(input.value, 10) || 0
					value = Math.max(0, value - 1)
					input.value = value
				})
			}

			input.addEventListener('change', () => {
				if (input.value < 0) input.value = 0
			})
		})
	})
}
handleVariantsTable()

const handleTabSidebar = (tab, banner) => {
	let sidebar = tab.querySelector('.sidebar')
	if (!sidebar) {
		const originalContent = tab.children
		const contentLength = originalContent.length
		const originalContentWrapper = document.createElement('div')
		for (let i = 0; i < contentLength; i++) {
			originalContentWrapper.appendChild(originalContent[0])
		}
		tab.innerHTML = ''
		tab.appendChild(originalContentWrapper)
		sidebar = document.createElement('div')
		sidebar.classList.add('sidebar')
		tab.appendChild(sidebar)
		tab.classList.add('with-sidebar')
	}
	sidebar.appendChild(banner)
}

// const mapkaBanner = document.querySelector(".prodejny-produkt");
// if (mapkaBanner) {
//   const help = mapkaBanner.closest(".banner").parentElement;
//   if (dataLayer[0].shoptet.pageType === "productDetail") {
//     if (document.body.classList.contains("discontinued-product")) {
//       help.remove();
//     } else {
//       const whereToAppend =
//         document.querySelector("#description .extended-description") ||
//         document.createElement("div");
//       if (!whereToAppend.classList.contains("extended-description"))
//         whereToAppend.classList.add("extended-description", "custom");
//       if (whereToAppend.classList.contains("custom")) {
//         const descriptionInner = document.querySelector(
//           "#description .description-inner"
//         );
//         if (descriptionInner) descriptionInner.appendChild(whereToAppend);
//       }
//       if (whereToAppend) {
//         whereToAppend.appendChild(help);
//       } else {
//         help.remove();
//       }
//       const productVideos = document.querySelector("#productVideos");
//       if (productVideos) handleTabSidebar(productVideos, help.cloneNode(true));
//       const productFiles = document.querySelector("#relatedFiles");
//       if (productFiles) handleTabSidebar(productFiles, help.cloneNode(true));
//       const productRating = document.querySelector("#ratingTab");
//       if (productRating) handleTabSidebar(productRating, help.cloneNode(true));
//       const productDiscussion = document.querySelector("#productDiscussion");
//       if (productDiscussion)
//         handleTabSidebar(productDiscussion, help.cloneNode(true));
//     }
//   } else {
//     help.remove();
//   }
// }
// const faqDetailBanner = document.querySelector(".faq-product");
// if (faqDetailBanner) {
//   const help = faqDetailBanner.closest(".banner").parentElement;
//   if (dataLayer[0].shoptet.pageType === "productDetail") {
//     if (document.body.classList.contains("discontinued-product")) {
//       const shpTabsWrapper = document.querySelector(".shp-tabs-wrapper");
//       if (shpTabsWrapper) {
//         shpTabsWrapper.parentElement.insertBefore(help, shpTabsWrapper);
//       } else {
//         help.remove();
//       }
//     } else {
//       const whereToAppend =
//         document.querySelector("#description .extended-description") ||
//         document.createElement("div");
//       if (!whereToAppend.classList.contains("extended-description"))
//         whereToAppend.classList.add("extended-description", "custom");
//       if (whereToAppend.classList.contains("custom")) {
//         const descriptionInner = document.querySelector(
//           "#description .description-inner"
//         );
//         if (descriptionInner) descriptionInner.appendChild(whereToAppend);
//       }
//       if (whereToAppend) {
//         whereToAppend.appendChild(help);
//       } else {
//         help.remove();
//       }
//       const productVideos = document.querySelector("#productVideos");
//       if (productVideos) handleTabSidebar(productVideos, help.cloneNode(true));
//       const productFiles = document.querySelector("#relatedFiles");
//       if (productFiles) handleTabSidebar(productFiles, help.cloneNode(true));
//       const productRating = document.querySelector("#ratingTab");
//       if (productRating) handleTabSidebar(productRating, help.cloneNode(true));
//       const productDiscussion = document.querySelector("#productDiscussion");
//       if (productDiscussion)
//         handleTabSidebar(productDiscussion, help.cloneNode(true));
//     }
//   } else {
//     help.remove();
//   }
// }

const nextToCarouselBanners = document.querySelector('.next-to-carousel-banners')
if (nextToCarouselBanners) {
	const benefitBanner = document.querySelector('.benefitBanner')
	if (benefitBanner) {
		benefitBanner.after(nextToCarouselBanners)
	} else {
		console.warn('Benefit banner not found, appending next to carousel banners')
	}
}

// hide more than 5 categories in menu-level-2 on mobile
if (window.innerWidth < 768) {
	const menuLevel2s = document.querySelectorAll('.navigation-in .menu-level-2-helper')
	if (menuLevel2s.length) {
		menuLevel2s.forEach((menu) => {
			const categories = menu.querySelectorAll('.menu-level-2 > li')
			if (categories.length > 4) {
				categories.forEach((category, index) => {
					if (index > 4) category.classList.add('hidden')
				})
				if (!menu.querySelector('.show-more-categories')) {
					const showMoreButton = document.createElement('button')
					showMoreButton.classList.add('show-more-categories', 'btn', 'btn-secondary')
					showMoreButton.innerHTML = 'Zobrazit všechny podkategorie'
					const menuList = menu.querySelector('.menu-level-2')
					if (menuList) menuList.appendChild(showMoreButton)
					showMoreButton.addEventListener('click', () => {
						categories.forEach((category) => {
							category.classList.toggle('hidden')
						})
						// showMoreButton.remove()
						showMoreButton.innerHTML = categories[5].classList.contains('hidden') ? 'Zobrazit všechny podkategorie' : 'Sbalit podkategorie'
					})
				}
			}
		})
	}
}

// move lofout button to the end of the menu
if (document.body.classList.contains('customer-page')) {
	const logoutButton = document.querySelector('.logout')
	const menu = document.querySelector('.client-center-box > ul')
	if (logoutButton && menu) {
		menu.appendChild(logoutButton)
	}
}
// const projectId = getShoptetDataLayer("projectId");

// let apiBaseURL = "";
// if (projectId === 727278) {
//   apiBaseURL = "https://advantage.mirandamedia.io/";
// }
// if (projectId === 758120) {
//   apiBaseURL = "https://advantage-test.mirandamedia.io/";
// }
const apiBaseURL =
	dataLayer[0].shoptet.projectId == '727278' ? 'https://advantage.mirandamedia.io/' : 'https://advantage-test.mirandamedia.io/'

const baseAPIURL = apiBaseURL + 'api/'

const validateProductsForVAT = async (e) => {
	e.preventDefault()
	e.stopPropagation()

	const productsInCart = dataLayer[0].shoptet.cart?.map((product) => product.code)
	try {
		const response = await fetch(baseAPIURL + 'company-id-required', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ productCodes: productsInCart }),
		})
		const data = await response.json()
		if (data?.required) {
			const vatInput = document.querySelector('#companyId')
			if (!Boolean(vatInput.value)) {
				alert('Pro nákup těchto produktů je nutné zadat IČO.')
			} else {
				e.target.submit()
			}
		} else if (data?.required === false) {
			e.target.submit()
		} else {
			console.error('Error fetching VAT validation data')
		}
	} catch (e) {
		console.error('Error fetching VAT validation data', e)
	}
}
const orderForm = document.querySelector('.id--17 #order-form')
if (orderForm) orderForm.addEventListener('submit', validateProductsForVAT)

const createPackageNonVariant = (data) => {
	if (!data || !data?.package) return
	const packageWrapper = document.createElement('div')
	packageWrapper.classList.add('package-wrapper')
	packageWrapper.setAttribute('data-code', data.code)
	const priceMain = (data.vatIncluded ? data.price * (1.0 - data.vatRate / 100) : data.price * (1.0 + data.vatRate / 100)).toFixed(2)
	const priceSecondary = (data.vatIncluded ? data.price * (1.0 + data.vatRate / 100) : data.price).toFixed(2)
	packageWrapper.innerHTML = `
		<div class="p-final-price-wrapper">
			${data.percentualDiscount > 0 ? `<div class="package-save">Ušetříte ${data.percentualDiscount} %</div>` : ''}
			<strong class="price-final" data-testid="productCardPrice">
				<span class="price-final-holder">
					${priceMain} Kč
					<span class="pr-list-unit"> /&nbsp;${data.packageUnit} </span>
				</span>
			</strong>
			<span class="price-additional"> ${priceSecondary} Kč bez DPH </span>
		</div>
		<div class="quantity-cart-wrapper">
			<span class="quantity">
				<span
					class="increase-tooltip js-increase-tooltip"
					data-trigger="manual"
					data-container="body"
					data-original-title="Není možné zakoupit více než 9999 ks."
					aria-hidden="true"
					role="tooltip"
					data-testid="tooltip">
				</span>

				<span
					class="decrease-tooltip js-decrease-tooltip"
					data-trigger="manual"
					data-container="body"
					data-original-title="Minimální množství, které lze zakoupit, je 1 ks."
					aria-hidden="true"
					role="tooltip"
					data-testid="tooltip">
				</span>
				<label>
					<input
						type="number"
						name="amount-package"
						id="amount-package"
						value="1"
						class="amount"
						autocomplete="off"
						data-decimals="0"
						step="1"
						min="1"
						max="9999"
						aria-label="Množství"
						data-testid="cartAmount" />
				</label>

				<button class="increase" type="button" aria-label="Zvýšit množství o 1" data-testid="increase">
					<span class="increase__sign">+</span>
				</button>

				<button class="decrease" type="button" aria-label="Snížit množství o 1" data-testid="decrease">
					<span class="decrease__sign">−</span>
				</button>
			</span>
			<div class="add-to-cart" data-testid="divAddToCart">
				<button class="btn btn-lg btn-conversion add-to-cart-button">
					Přidat celé balení ${data.pcsInPackage} ${data.unit}
				</button>
			</div>
		</div>
	`
	const addPackageToCartBtn = packageWrapper.querySelector('.add-to-cart-button')
	if (addPackageToCartBtn) {
		addPackageToCartBtn.addEventListener('click', async (e) => {
			e.preventDefault()
			e.stopPropagation()
			shoptet.cartShared.addToCart({
				productCode: data.packageCode,
				amount: parseInt(packageWrapper.querySelector('input[name="amount-package"]')?.value) || 1,
			})
		})
	}
	return packageWrapper
}

const createPackageVarianta = (data) => {
	if (!data) return
	const priceMain = (data.vatIncluded ? data.price * (1.0 - data.vatRate / 100) : data.price * (1.0 + data.vatRate / 100)).toFixed(2)
	const priceSecondary = (data.vatIncluded ? data.price * (1.0 + data.vatRate / 100) : data.price).toFixed(2)

	const packageWrapper = document.createElement('div')
	packageWrapper.classList.add('variant-cart')
	packageWrapper.innerHTML = `
		<div class="variant-submit variant-package">
			<fieldset>
				<span class="quantity">
					<span
						class="increase-tooltip js-increase-tooltip"
						data-trigger="manual"
						data-container="body"
						data-original-title="Není možné zakoupit více než 9999 ks."
						aria-hidden="true"
						role="tooltip"
						data-testid="tooltip">
					</span>

					<span
						class="decrease-tooltip js-decrease-tooltip"
						data-trigger="manual"
						data-container="body"
						data-original-title="Minimální množství, které lze zakoupit, je 1 ks."
						aria-hidden="true"
						role="tooltip"
						data-testid="tooltip">
					</span>
					<label>
						<input
							type="number"
							name="amount"
							value="0"
							class="amount"
							autocomplete="off"
							data-decimals="0"
							step="1"
							min="0"
							max="9999"
							aria-label="Množství"
							data-testid="cartAmount" />
					</label>

					<button class="increase" type="button" aria-label="Zvýšit množství o 1" data-testid="increase">
						<span class="increase__sign">+</span>
					</button>

					<button class="decrease" type="button" aria-label="Snížit množství o 1" data-testid="decrease">
						<span class="decrease__sign">−</span>
					</button>
				</span>
				<div class="variant-price-wrap">
					<div class="price-final" data-testid="productVariantPrice">
						${priceMain} ${data.currencyCode === 'CZK' ? 'Kč' : '€'}
						
						<span class="pr-list-unit"> /&nbsp;${data.packageUnit} <span>(${data.pcsInPackage}ks)</span></span></span>
						</div>
						${data.percentualDiscount > 0 ? `<div class="package-save">Ušetříte ${data.percentualDiscount} %</div>` : ''}
						<div class="price-additional">${priceSecondary} Kč bez DPH</div>
					</div>
					<div type="submit" class="btn btn-plain btn-cart add-to-cart-button" data-testid="buttonAddToCart">
						<span class="sr-only">Do košíku</span>
					</div>
				</div>
			</fieldset>
		</div>`

	const addPackageToCartBtn = packageWrapper.querySelector('.add-to-cart-button')
	if (addPackageToCartBtn) {
		addPackageToCartBtn.addEventListener('click', async (e) => {
			e.preventDefault()
			e.stopPropagation()
			shoptet.cartShared.addToCart({
				productCode: data.packageCode,
				amount: parseInt(packageWrapper.querySelector('input[name="amount"]')?.value) || 1,
			})
		})
	}
	return packageWrapper
}

const getPackageProduct = async () => {
	const productCodes = dataLayer[0].shoptet.product.codes
	const customerGUID = dataLayer[0].shoptet.customer?.guid || null
	const hasVariants = document.querySelector('.variant-table')
	const codes = productCodes.map((item) => item.code)?.join(',')
	try {
		const response = await fetch(
			`${baseAPIURL}product-variant-package-units/codes/${codes}?customerGuid=${customerGUID}&currencyCode=${dataLayer[0].shoptet.currency}`,
		)
		console.log(
			`${baseAPIURL}product-variant-package-units/codes/${codes}?customerGuid=${customerGUID}&currencyCode=${dataLayer[0].shoptet.currency}`,
		)
		const data = await response.json()
		if (!data) return
		if (hasVariants) {
			for (let i = 0; i < productCodes.length; i++) {
				const variantData = data.filter((item) => item.code == productCodes[i].code)
				if (!variantData || !variantData[0]?.package) continue
				const variantRow = hasVariants.querySelector(`.product-stock-amount[data-variant-code="${variantData[0].code}"]`)
				if (variantRow) {
					const variantCart = variantRow?.closest('.table-row').querySelector('.table-col:has(.variant-cart)')
					if (variantCart) variantCart.appendChild(createPackageVarianta(variantData[0]))
				} else {
					const allEans = hasVariants.querySelectorAll('.productEan__value')
					if (allEans.length > 0) {
						const ean = variantData[0].ean
						allEans.forEach((eanEl) => {
							if (eanEl.innerText === ean) {
								const variantCart = eanEl.closest('.table-row').querySelector('.table-col:has(.variant-cart)')
								if (variantCart) {
									variantCart.appendChild(createPackageVarianta(variantData[0]))
									return
								}
							}
						})
					}
				}
			}
		} else {
			const addToCartWrapper = document.querySelector('.add-to-cart-wrapper')
			if (addToCartWrapper) {
				const packageElement = createPackageNonVariant(data.filter((item) => item.code === dataLayer[0].shoptet.product.code)[0])
				if (packageElement) {
					addToCartWrapper.appendChild(packageElement)
				}
			}
		}
	} catch (e) {
		console.error(e)
	}
}
if (dataLayer[0].shoptet.pageType === 'productDetail') getPackageProduct()

const handleAvailableShippingMethods = async () => {
	const productCodes = {}
	dataLayer[0].shoptet.cart?.forEach((product) => (productCodes[product.code] = product.quantity))
	console.log(productCodes)

	const shippingMethods = document.querySelectorAll('#order-shipping-methods .radio-wrapper')
	try {
		const response = await fetch(
			baseAPIURL + 'restrictions-on-transport-and-payments?customerGuid=' + dataLayer[0].shoptet.customer?.guid,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ productCodes }),
			},
		)
		const data = await response.json()
		if (!data) return
		const availableGuids = Object.keys(data.allowedShippings)
		for (let i = 0; i < shippingMethods.length; i++) {
			const method = shippingMethods[i]

			const methodGuid = method.querySelector('input[name="shippingId"]')?.getAttribute('data-guid')
			if (availableGuids.length === 0) {
				if (methodGuid && methodGuid !== '8fdb2c89-3fae-11e2-a723-705ab6a2ba75') method.remove()
			} else {
				if (methodGuid && !availableGuids.includes(methodGuid)) method.remove()
			}
		}
		const availablePaymentGuids = Object.keys(data.allowedPayments)
		const paymentMethods = document.querySelectorAll('#order-billing-methods .radio-wrapper')
		for (let i = 0; i < paymentMethods.length; i++) {
			const method = paymentMethods[i]
			const methodGuid = method.querySelector('input[name="billingId"]')?.getAttribute('data-guid')
			if (availablePaymentGuids.length === 0) {
				if (methodGuid && methodGuid !== '8fdb2c88-3fae-11e2-a723-705ab6a2ba75') method.remove()
			} else {
				if (methodGuid && !availablePaymentGuids.includes(methodGuid)) method.remove()
			}
		}
		if (data.dangerous) {
			console.log(data.dangerous)
			const shippingBox = document.querySelector('#order-shipping-methods')
			let pscInput = document.querySelector('#billZip')
			if (!pscInput) {
				const wrapper = document.createElement('div')
				wrapper.className = 'form-group js-validated-element-wrapper smart-label-wrapper'

				wrapper.innerHTML = `
				<label for="billZip">
					<span class="required-asterisk">PSČ</span>
				</label>
				<input type="text" id="billZip" name="billZip" class="form-control short" autocomplete="postal-code" placeholder="Napište PSČ">
				<div class="js-validator-msg msg-error" data-type="validatorZipCode" style="display:none;"></div>
			`
				shippingBox.parentNode.insertBefore(wrapper, shippingBox)
				pscInput = wrapper.querySelector('#billZip')
			}

			const savedPSC = sessionStorage.getItem('psc')
			if (savedPSC) {
				pscInput.value = savedPSC
			}

			pscInput.addEventListener('input', () => {
				const onlyDigits = pscInput.value.replace(/\D/g, '')
				sessionStorage.setItem('psc', onlyDigits)
			})

			const handleAvailableShippingMethods = () => {
				const onlyDigits = pscInput.value.replace(/\D/g, '')
				const pscMap = [
					{ from: 10000, to: 25000, id: 'shipping-63' },
					{ from: 25001, to: 34999, id: 'shipping-72' },
					{ from: 35000, to: 52999, id: 'shipping-75' },
					{ from: 53000, to: 73510, id: 'shipping-78' },
					{ from: 73511, to: 79999, id: 'shipping-81' },
					{ from: 80000, to: 85999, id: 'shipping-84' },
					{ from: 90000, to: 95999, id: 'shipping-87' },
					{ from: 96000, to: 99999, id: 'shipping-99' },
					{ from: '01000', to: '03999', id: 'shipping-96' },
					{ from: '04000', to: '09999', id: 'shipping-102' },
				]

				const findShippingByPSC = (psc) => {
					const numeric = parseInt(psc, 10)
					return pscMap.find((item) => numeric >= item.from && numeric <= item.to)
				}

				const errorDiv = document.querySelector(".js-validator-msg.msg-error[data-type='validatorZipCode']")
				if (!errorDiv) return

				const hideAll = () => {
					pscMap.forEach((item) => {
						const row = document.getElementById(item.id)
						if (row) row.style.display = 'none'
					})
				}

				if (onlyDigits.length === 0 || onlyDigits.length < 5) {
					hideAll()
					errorDiv.style.display = 'none'
					return
				}

				if (onlyDigits.length > 5) {
					errorDiv.textContent = 'PSČ může obsahovat maximálně 5 číslic.'
					errorDiv.style.display = 'block'
					hideAll()
					return
				} else {
					errorDiv.style.display = 'none'
				}

				const matched = findShippingByPSC(onlyDigits)
				if (!matched) {
					errorDiv.textContent = 'Pro zadané PSČ není dostupná doprava Raben ADR.'
					errorDiv.style.display = 'block'
					hideAll()
					return
				}

				errorDiv.style.display = 'none'

				pscMap.forEach((item) => {
					const row = document.getElementById(item.id)
					if (!row) return
					const input = row.querySelector("input[name='shippingId']")
					if (!input) return

					if (item.id === matched.id) {
						row.style.display = 'block'
						row.classList.remove('active')
					} else {
						row.style.display = 'none'
						row.classList.remove('active')
					}

					input.checked = false
					input.dispatchEvent(new Event('change', { bubbles: true }))
				})
			}

			pscInput.addEventListener('input', handleAvailableShippingMethods)
			handleAvailableShippingMethods()
			validateBillZipBeforeNextStep()
		}
	} catch (e) {
		console.error(e)
	}
}
if (dataLayer[0].shoptet.pageType === 'billingAndShipping') handleAvailableShippingMethods()

// const setupShippingMethodsAndBillZip = () => {
// 	if (shippingBox) {
// 		// const rabenIds = ['shipping-63', 'shipping-72', 'shipping-75', 'shipping-78', 'shipping-81']
// 		// const allMethods = Array.from(shippingBox.querySelectorAll('.radio-wrapper'))
// 		// const hasOtherMethods = allMethods.some((method) => !rabenIds.includes(method.id))

// 		// if (hasOtherMethods) {
// 		// 	rabenIds.forEach((id) => {
// 		// 		const row = document.getElementById(id)
// 		// 		if (row) row.style.display = 'none'
// 		// 	})
// 		// }

// 		let pscInput = document.querySelector('#billZip')
// 		if (!pscInput) {
// 			const wrapper = document.createElement('div')
// 			wrapper.className = 'form-group js-validated-element-wrapper smart-label-wrapper'

// 			wrapper.innerHTML = `
// 				<label for="billZip">
// 					<span class="required-asterisk">PSČ</span>
// 				</label>
// 				<input type="text" id="billZip" name="billZip" class="form-control short" autocomplete="postal-code" placeholder="Napište PSČ">
// 				<div class="js-validator-msg msg-error" data-type="validatorZipCode" style="display:none;"></div>
// 			`
// 			shippingBox.parentNode.insertBefore(wrapper, shippingBox)
// 			pscInput = wrapper.querySelector('#billZip')
// 		}

// 		const savedPSC = sessionStorage.getItem('psc')
// 		if (savedPSC) {
// 			pscInput.value = savedPSC
// 		}

// 		pscInput.addEventListener('input', () => {
// 			const onlyDigits = pscInput.value.replace(/\D/g, '')
// 			sessionStorage.setItem('psc', onlyDigits)
// 		})

// 		const handleAvailableShippingMethods = () => {
// 			const onlyDigits = pscInput.value.replace(/\D/g, '')
// 			const pscMap = [
// 				{ from: 10000, to: 25000, id: 'shipping-63' },
// 				{ from: 25001, to: 34999, id: 'shipping-72' },
// 				{ from: 35000, to: 52999, id: 'shipping-75' },
// 				{ from: 53000, to: 73510, id: 'shipping-78' },
// 				{ from: 73511, to: 79999, id: 'shipping-81' },
// 			]

// 			const findShippingByPSC = (psc) => {
// 				const numeric = parseInt(psc, 10)
// 				return pscMap.find((item) => numeric >= item.from && numeric <= item.to)
// 			}

// 			const errorDiv = document.querySelector(".js-validator-msg.msg-error[data-type='validatorZipCode']")
// 			if (!errorDiv) return

// 			const hideAll = () => {
// 				pscMap.forEach((item) => {
// 					const row = document.getElementById(item.id)
// 					if (row) row.style.display = 'none'
// 				})
// 			}

// 			if (onlyDigits.length === 0 || onlyDigits.length < 5) {
// 				hideAll()
// 				errorDiv.style.display = 'none'
// 				return
// 			}

// 			if (onlyDigits.length > 5) {
// 				errorDiv.textContent = 'PSČ může obsahovat maximálně 5 číslic.'
// 				errorDiv.style.display = 'block'
// 				hideAll()
// 				return
// 			} else {
// 				errorDiv.style.display = 'none'
// 			}

// 			const matched = findShippingByPSC(onlyDigits)
// 			if (!matched) {
// 				errorDiv.textContent = 'Pro zadané PSČ není dostupná doprava Raben ADR.'
// 				errorDiv.style.display = 'block'
// 				hideAll()
// 				return
// 			}

// 			errorDiv.style.display = 'none'

// 			pscMap.forEach((item) => {
// 				const row = document.getElementById(item.id)
// 				if (!row) return
// 				const input = row.querySelector("input[name='shippingId']")
// 				if (!input) return

// 				if (item.id === matched.id) {
// 					row.style.display = 'block'
// 					row.classList.remove('active')
// 				} else {
// 					row.style.display = 'none'
// 					row.classList.remove('active')
// 				}

// 				input.checked = false
// 				input.dispatchEvent(new Event('change', { bubbles: true }))
// 			})
// 		}

// 		pscInput.addEventListener('input', handleAvailableShippingMethods)
// 		handleAvailableShippingMethods()
// 	}
// }
const validateBillZipBeforeNextStep = () => {
	const nextButton = document.querySelector('#orderFormButton')
	const pscInput = document.querySelector('#billZip')
	const errorDiv = document.querySelector(".js-validator-msg.msg-error[data-type='validatorZipCode']")
	const stepLink = document.querySelector('li.step.step-3 a')

	if (nextButton && pscInput && errorDiv) {
		const validatePSC = (e) => {
			const onlyDigits = pscInput.value.replace(/\D/g, '')

			if (onlyDigits.length < 5) {
				e.preventDefault()
				e.stopImmediatePropagation()
				errorDiv.textContent = 'Prosím, vyplňte PSČ (5 číslic).'
				errorDiv.style.display = 'block'
				pscInput.focus()
				return false
			}

			errorDiv.style.display = 'none'
			return true
		}

		nextButton.addEventListener('click', validatePSC, { capture: true })

		if (stepLink) {
			stepLink.addEventListener(
				'click',
				(e) => {
					validatePSC(e)
				},
				{ capture: true },
			)
		}
	}
}
const setupCustomerDetailsZip = () => {
	const savedPSC = sessionStorage.getItem('psc')
	if (!savedPSC) return
	const billZip = document.querySelector('#billZip')
	const deliveryZip = document.querySelector('#deliveryZip')
	const anotherShippingCheckbox = document.querySelector('#another-shipping')

	deliveryZip.value = savedPSC

	const applyRules = () => {
		if (!anotherShippingCheckbox.checked) {
			billZip.value = savedPSC
			billZip.readOnly = true
			billZip.classList.add('readonly-input')

			deliveryZip.value = savedPSC
			deliveryZip.readOnly = true
			deliveryZip.classList.add('readonly-input')

			deliveryZip.setAttribute('readonly', 'readonly')
			billZip.setAttribute('readonly', 'readonly')

			if (!billZip.parentNode.querySelector('.psc-info')) {
				const info = document.createElement('span')
				info.className = 'psc-info'
				info.textContent = '(PSČ lze změnit pouze v předchozím kroku.)'
				billZip.parentNode.querySelector('label').appendChild(info)
			}

			if (!deliveryZip.parentNode.querySelector('.psc-info')) {
				const info2 = document.createElement('span')
				info2.className = 'psc-info'
				info2.textContent = '(PSČ lze změnit pouze v předchozím kroku.)'
				deliveryZip.parentNode.querySelector('label').appendChild(info2)
			}
		} else {
			billZip.readOnly = false
			billZip.classList.remove('readonly-input')
			billZip.removeAttribute('readonly')

			const info = billZip.parentNode.querySelector('.psc-info')
			if (info) info.remove()

			deliveryZip.value = savedPSC
			deliveryZip.readOnly = true
			deliveryZip.classList.add('readonly-input')
			deliveryZip.setAttribute('readonly', 'readonly')

			if (!deliveryZip.parentNode.querySelector('.psc-info')) {
				const info2 = document.createElement('span')
				info2.className = 'psc-info'
				info2.textContent = '(PSČ lze změnit pouze v předchozím kroku.)'
				deliveryZip.parentNode.querySelector('label').appendChild(info2)
			}
		}
	}

	applyRules()
	anotherShippingCheckbox.addEventListener('change', applyRules)
}

// if (dataLayer[0].shoptet.pageType === 'billingAndShipping') {
// 	setupShippingMethodsAndBillZip()
// 	validateBillZipBeforeNextStep()
// }
if (dataLayer[0].shoptet.pageType === 'customerDetails') {
	setupCustomerDetailsZip()
}

const getInvoiceByOrderCode = async (orderCode) => {
	try {
		const response = await fetch(`${baseAPIURL}shoptet/documents/order/${orderCode}`)
		const data = await response.json()
		if (data.length) return data
	} catch (error) {
		console.error(error)
	}
}
const handleInvoices = async () => {
	const ordersTable = document.querySelector('.table.customer-orders')
	if (!ordersTable) return
	const orderRows = ordersTable.querySelectorAll('tbody tr')
	if (!orderRows.length) return
	const invoiceHeader = document.createElement('th')
	invoiceHeader.textContent = 'Faktura'
	ordersTable.querySelector('thead tr')?.appendChild(invoiceHeader)
	for (let i = 0; i < orderRows.length; i++) {
		const row = orderRows[i]
		const orderCode = row.querySelector('[data-testid="linkCustomerOrder"]')?.textContent.trim()
		if (!orderCode) continue
		const invoice = await getInvoiceByOrderCode(orderCode)
		if (!invoice) continue
		const invoiceCell = document.createElement('td')
		const invoiceLink = document.createElement('a')
		const invoiceTableHeading = document.createElement('span')
		invoiceTableHeading.classList.add('client-table-heading')
		invoiceTableHeading.innerHTML = 'Faktura'
		invoiceLink.href = invoice[0].url
		invoiceLink.target = '_blank'
		invoiceLink.rel = 'noopener noreferrer'
		invoiceLink.innerHTML = invoice[0].name
		invoiceCell.appendChild(invoiceTableHeading)
		invoiceCell.appendChild(invoiceLink)
		row.appendChild(invoiceCell)
	}
}
if (document.body.classList.contains('customer-page')) handleInvoices()

const handleShippingPopupDetail = () => {
	const shippingPopup = document.querySelector('.shipping-options-popup')
	if (!shippingPopup) return

	const shippingRows = shippingPopup.querySelectorAll('.shipping-row')
	if (!shippingRows.length) return
	shippingRows.forEach((row) => {
		const shippingName = row.querySelector('.shipping-billing-name')
		const shippingPrice = row.querySelector('.payment-shipping-price')

		if (shippingName && shippingPrice) {
			if (shippingName.textContent.includes('Individuální doprava')) {
				shippingPrice.textContent = individualPrice ? individualPrice : 'Individuální kalkulace'
			}
		}
	})
	const extraDelivery = shippingPopup.querySelector('.extra.delivery')
	if (extraDelivery) {
		if (extraDelivery.textContent.includes('Dopravu máte zdarma')) {
			extraDelivery.style.display = 'none'
		}
	}
}
const handleAvailableShippingMethodsPopup = async () => {
	if (!document.body.classList.contains('type-detail')) return
	const targetProduct = dataLayer[0].shoptet.product.code
	const prodQty = document.querySelector('.quantity-cart-wrapper .amount')

	const productCodes = {
		[targetProduct]: prodQty ? parseInt(prodQty.value) : 1,
	}

	if (!productCodes) return

	//console.log(productCodes)

	const shippingMethods = document.querySelectorAll('.shipping-options-popup .shipping-row')
	//console.log(baseAPIURL)
	try {
		const response = await fetch(
			baseAPIURL + 'restrictions-on-transport-and-payments?customerGuid=' + dataLayer[0].shoptet.customer?.guid,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ productCodes }),
			},
		)
		const data = await response.json()
		if (!data || !data.allowedShippings) return

		const allowedShippings = data.allowedShippings
		const availableGuids = Object.keys(allowedShippings)
		//console.log('Dostupné GUIDs:', availableGuids);
		//console.log('Dostupné názvy:', Object.values(allowedShippings));

		// Najdi mapování GUID → název
		const guidToName = {}
		Object.entries(allowedShippings).forEach(([guid, name]) => {
			guidToName[guid] = name
		})

		for (let method of shippingMethods) {
			const methodName = method.querySelector('.shipping-billing-name')?.textContent.trim()
			if (!methodName) continue

			const isAllowed = Object.values(allowedShippings).includes(methodName)

			if (!isAllowed) {
				//console.log('Skrytá doprava:', methodName);
				method.remove()
			}
		}
	} catch (e) {
		console.error('Chyba API:', e)
	}
}
document.addEventListener('shoptet.modal.open', () => {
	setTimeout(function () {
		handleAvailableShippingMethodsPopup()
	}, 20)
	setTimeout(function () {
		handleShippingPopupDetail()
	}, 100)
})

document.addEventListener('DOMContentLoaded', () => {
	if (document.body.classList.contains('in-krok-1')) {
		const shippingIndividual = document.getElementById('shipping-29')
		if (shippingIndividual) {
			const changeText = shippingIndividual.querySelector('.payment-shipping-price')
			if (changeText) {
				changeText.textContent = individualPrice ? individualPrice : 'Individuální kalkulace'
			}
		}
	}
})

const handleFreeShippingProgress = async () => {
	const productCodes = {}
	dataLayer[0].shoptet.cart?.forEach((product) => (productCodes[product.code] = product.quantity))
	try {
		const response = await fetch(
			baseAPIURL + 'restrictions-on-transport-and-payments?customerGuid=' + dataLayer[0].shoptet.customer?.guid,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ productCodes }),
			},
		)
		const data = await response.json()
		if (!data) return
		const availableGuids = Object.keys(data.allowedShippings)
		console.log(availableGuids)

		const extraDelivery = document.querySelector('.extra.delivery') || document.querySelector('.cart-free-shipping')
		let canHaveFreeShipping = false
		availableGuids.forEach((guid) => {
			console.log(guid)
			console.log(cenyDoprav[guid])
			if (cenyDoprav[guid]) canHaveFreeShipping = true
		})
		if (!canHaveFreeShipping && extraDelivery) {
			extraDelivery.style.display = 'none'
		} else if (canHaveFreeShipping && extraDelivery) {
			let priceToFree = 0
			const cartTotal = dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withVat
			availableGuids.forEach((guid) => {
				if (cenyDoprav[guid]?.priceToFree?.[dataLayer[0].shoptet.currency])
					if (priceToFree === 0 || cenyDoprav[guid].priceToFree?.[dataLayer[0].shoptet.currency] < priceToFree)
						priceToFree = cenyDoprav[guid].priceToFree?.[dataLayer[0].shoptet.currency]
			})
			const priceToFreeLeft = priceToFree - cartTotal
			const priceRangeWidth = (cartTotal / priceToFree) * 100
			console.log('width', priceRangeWidth)
			console.log('cartTotal', cartTotal)
			console.log('priceToFree', priceToFree)
			console.log('priceToFreeLeft', priceToFreeLeft)
			if (priceToFreeLeft > 0) {
				extraDelivery.style.display = 'block'
				extraDelivery.innerHTML = `
			  <span>
			    Objednejte ještě za <strong>${priceToFreeLeft.toLocaleString('cs-CZ')} ${dataLayer[0].shoptet.currencyInfo.symbol}</strong> a budete mít dopravu <strong>ZDARMA</strong>.
			    <div class="price-range"><div style="width: ${priceRangeWidth}%"></div></div>
			  </span>
			`
				extraDelivery.classList.remove('free-shipping')
			}
		}
	} catch (error) {
		console.error(error)
	}
}

if (typeof cenyDoprav !== 'undefined' && cenyDoprav !== null) {
	if (dataLayer[0].shoptet.pageId == '-9') {
		handleFreeShippingProgress()
	}
	document.addEventListener('ShoptetDOMCartContentLoaded', () => {
		handleFreeShippingProgress()
	})
}
